<script>
import moment from 'moment'

export default {
  name: 'tourists',
  computed: {
    tourists() {
      return this.$store.getters['order/getTourists']
    },
    getDocumentTypes() {
      return this.$store.getters['order/getInclude'].documentTypes
    },
  },
  methods: {
    formatDate: date => (date === null
      ? null
      : moment.unix(date).format('DD.MM.YYYY')),
    getDocumentType(type) {
      return this.getDocumentTypes[type]
    }
  }
}
</script>

<template>
  <div
    v-if="tourists.length"
    class="order__tourists-info"
  >
    <div class="order-tourists">
      <h2 class="order__title">
        Данные о туристах
      </h2>
      <div
        v-for="(tourist, index) in tourists"
        :key="index"
        class="order-tourists__tourist"
      >
        <p class="order-tourists__tourist-number">
          Турист {{ index + 1 }}
        </p>
        <div>
          <p class="order-tourists__tourist-name">
            {{ tourist.name }} {{ tourist.surname }} {{ tourist.middleName }}
          </p>
          <p class="order-tourists__tourist-info order-tourists__tourist-info--bottom">
            {{ tourist.gender === 'm' ? 'мужчина' : 'женщина' }},
            {{ formatDate(tourist.birthday) }}
          </p>
          <p class="order-tourists__tourist-info">
            {{ getDocumentType(tourist.document.type) }}
            {{ tourist.document.number }}
            {{ tourist.document.expirationDate ? 'действует до' : null }}
            {{ formatDate(tourist.document.expirationDate) }}
          </p>
        </div>
        <div class="order-tourists__tourist-contacts">
          <p>{{ tourist.email }}</p>
          <p>{{ tourist.phone }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
